@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_774_514_053)
public val Res.string.staff_import_column_samples: StringResource by lazy {
      StringResource("string:staff_import_column_samples", "staff_import_column_samples", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334028, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476140, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306427, 59),
      ))
    }

@delegate:ResourceContentHash(1_891_199_360)
public val Res.string.staff_import_count_fix: StringResource by lazy {
      StringResource("string:staff_import_count_fix", "staff_import_count_fix", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334132, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476264, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306531, 50),
      ))
    }

@delegate:ResourceContentHash(389_082_932)
public val Res.string.staff_import_count_ready: StringResource by lazy {
      StringResource("string:staff_import_count_ready", "staff_import_count_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334207, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476359, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306582, 52),
      ))
    }

@delegate:ResourceContentHash(559_150_215)
public val Res.string.staff_import_count_skipped: StringResource by lazy {
      StringResource("string:staff_import_count_skipped", "staff_import_count_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334264, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476436, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306635, 46),
      ))
    }

@delegate:ResourceContentHash(-1_159_665_739)
public val Res.string.staff_import_done_added: StringResource by lazy {
      StringResource("string:staff_import_done_added", "staff_import_done_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334315, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476495, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306682, 47),
      ))
    }

@delegate:ResourceContentHash(-1_260_513_802)
public val Res.string.staff_import_done_back: StringResource by lazy {
      StringResource("string:staff_import_done_back", "staff_import_done_back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334363, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476555, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306730, 54),
      ))
    }

@delegate:ResourceContentHash(-775_457_318)
public val Res.string.staff_import_done_failed: StringResource by lazy {
      StringResource("string:staff_import_done_failed", "staff_import_done_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334418, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476626, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306785, 56),
      ))
    }

@delegate:ResourceContentHash(1_355_311_442)
public val Res.string.staff_import_done_hint: StringResource by lazy {
      StringResource("string:staff_import_done_hint", "staff_import_done_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334471, 222),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 476695, 402),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306842, 222),
      ))
    }

@delegate:ResourceContentHash(-272_029_374)
public val Res.string.staff_import_done_invite_failed: StringResource by lazy {
      StringResource("string:staff_import_done_invite_failed", "staff_import_done_invite_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334694, 155),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477098, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307065, 147),
      ))
    }

@delegate:ResourceContentHash(868_539_209)
public val Res.string.staff_import_done_invited: StringResource by lazy {
      StringResource("string:staff_import_done_invited", "staff_import_done_invited", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334850, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477322, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307213, 69),
      ))
    }

@delegate:ResourceContentHash(-41_033_884)
public val Res.string.staff_import_done_remaining: StringResource by lazy {
      StringResource("string:staff_import_done_remaining", "staff_import_done_remaining", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334924, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477460, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307283, 67),
      ))
    }

@delegate:ResourceContentHash(-697_402_952)
public val Res.string.staff_import_done_title: StringResource by lazy {
      StringResource("string:staff_import_done_title", "staff_import_done_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 334996, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477552, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307351, 51),
      ))
    }

@delegate:ResourceContentHash(1_593_342_606)
public val Res.string.staff_import_drop_hint: StringResource by lazy {
      StringResource("string:staff_import_drop_hint", "staff_import_drop_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335052, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477628, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307403, 106),
      ))
    }

@delegate:ResourceContentHash(-1_225_639_682)
public val Res.string.staff_import_drop_title: StringResource by lazy {
      StringResource("string:staff_import_drop_title", "staff_import_drop_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335167, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477791, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307510, 75),
      ))
    }

@delegate:ResourceContentHash(740_360_672)
public val Res.string.staff_import_edit_save: StringResource by lazy {
      StringResource("string:staff_import_edit_save", "staff_import_edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335247, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477895, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307586, 50),
      ))
    }

@delegate:ResourceContentHash(544_398_615)
public val Res.string.staff_import_edit_title: StringResource by lazy {
      StringResource("string:staff_import_edit_title", "staff_import_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335302, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 477982, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307637, 47),
      ))
    }

@delegate:ResourceContentHash(1_377_871_702)
public val Res.string.staff_import_exceeds_seats: StringResource by lazy {
      StringResource("string:staff_import_exceeds_seats", "staff_import_exceeds_seats", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335599, 274),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 478431, 430),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307926, 270),
      ))
    }

@delegate:ResourceContentHash(2_012_346_069)
public val Res.string.staff_import_exceeds_seats_ask_owner: StringResource by lazy {
      StringResource("string:staff_import_exceeds_seats_ask_owner", "staff_import_exceeds_seats_ask_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335358, 240),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 478062, 368),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307685, 240),
      ))
    }

@delegate:ResourceContentHash(51_595_108)
public val Res.string.staff_import_field_contract: StringResource by lazy {
      StringResource("string:staff_import_field_contract", "staff_import_field_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335874, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 478862, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308197, 55),
      ))
    }

@delegate:ResourceContentHash(-2_011_291_591)
public val Res.string.staff_import_field_email: StringResource by lazy {
      StringResource("string:staff_import_field_email", "staff_import_field_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335926, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 478930, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308253, 40),
      ))
    }

@delegate:ResourceContentHash(-445_830_002)
public val Res.string.staff_import_field_first_name: StringResource by lazy {
      StringResource("string:staff_import_field_first_name", "staff_import_field_first_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 335967, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479007, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308294, 53),
      ))
    }

@delegate:ResourceContentHash(52_432_886)
public val Res.string.staff_import_field_last_name: StringResource by lazy {
      StringResource("string:staff_import_field_last_name", "staff_import_field_last_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336013, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479057, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308348, 48),
      ))
    }

@delegate:ResourceContentHash(1_464_177_564)
public val Res.string.staff_import_field_name: StringResource by lazy {
      StringResource("string:staff_import_field_name", "staff_import_field_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336062, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479118, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308397, 43),
      ))
    }

@delegate:ResourceContentHash(1_463_311_320)
public val Res.string.staff_import_field_none: StringResource by lazy {
      StringResource("string:staff_import_field_none", "staff_import_field_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336118, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479194, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308441, 51),
      ))
    }

@delegate:ResourceContentHash(967_338_341)
public val Res.string.staff_import_field_pay_model: StringResource by lazy {
      StringResource("string:staff_import_field_pay_model", "staff_import_field_pay_model", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336166, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479262, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308493, 76),
      ))
    }

@delegate:ResourceContentHash(-1_962_543_618)
public val Res.string.staff_import_field_permission: StringResource by lazy {
      StringResource("string:staff_import_field_permission", "staff_import_field_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336267, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479395, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308570, 53),
      ))
    }

@delegate:ResourceContentHash(-544_901_234)
public val Res.string.staff_import_field_phone: StringResource by lazy {
      StringResource("string:staff_import_field_phone", "staff_import_field_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336321, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479469, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308624, 40),
      ))
    }

@delegate:ResourceContentHash(-1_694_983_890)
public val Res.string.staff_import_field_rate: StringResource by lazy {
      StringResource("string:staff_import_field_rate", "staff_import_field_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336366, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479522, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308665, 71),
      ))
    }

@delegate:ResourceContentHash(717_074_590)
public val Res.string.staff_import_field_role: StringResource by lazy {
      StringResource("string:staff_import_field_role", "staff_import_field_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336454, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479650, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308737, 43),
      ))
    }

@delegate:ResourceContentHash(-944_904_811)
public val Res.string.staff_import_field_shift_lead: StringResource by lazy {
      StringResource("string:staff_import_field_shift_lead", "staff_import_field_shift_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336502, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479698, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308781, 53),
      ))
    }

@delegate:ResourceContentHash(612_613_360)
public val Res.string.staff_import_field_student: StringResource by lazy {
      StringResource("string:staff_import_field_student", "staff_import_field_student", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336564, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479772, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308835, 70),
      ))
    }

@delegate:ResourceContentHash(71_541_725)
public val Res.string.staff_import_fix: StringResource by lazy {
      StringResource("string:staff_import_fix", "staff_import_fix", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336766, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 480058, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309013, 28),
      ))
    }

@delegate:ResourceContentHash(1_414_076_948)
public val Res.string.staff_import_fix_first: StringResource by lazy {
      StringResource("string:staff_import_fix_first", "staff_import_fix_first", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336639, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 479875, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308906, 106),
      ))
    }

@delegate:ResourceContentHash(713_283_833)
public val Res.string.staff_import_has_header: StringResource by lazy {
      StringResource("string:staff_import_has_header", "staff_import_has_header", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336799, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 480107, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309042, 79),
      ))
    }

@delegate:ResourceContentHash(-1_779_583_335)
public val Res.string.staff_import_include: StringResource by lazy {
      StringResource("string:staff_import_include", "staff_import_include", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336879, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 480227, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309122, 48),
      ))
    }

@delegate:ResourceContentHash(-1_132_092_915)
public val Res.string.staff_import_intro: StringResource by lazy {
      StringResource("string:staff_import_intro", "staff_import_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 336924, 234),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 480280, 358),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309171, 214),
      ))
    }

@delegate:ResourceContentHash(874_289_925)
public val Res.string.staff_import_mapping_hint: StringResource by lazy {
      StringResource("string:staff_import_mapping_hint", "staff_import_mapping_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337159, 217),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 480639, 341),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309386, 205),
      ))
    }

@delegate:ResourceContentHash(-1_237_735_082)
public val Res.string.staff_import_mapping_title: StringResource by lazy {
      StringResource("string:staff_import_mapping_title", "staff_import_mapping_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337377, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 480981, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309592, 66),
      ))
    }

@delegate:ResourceContentHash(2_141_428_970)
public val Res.string.staff_import_name_column_needed: StringResource by lazy {
      StringResource("string:staff_import_name_column_needed", "staff_import_name_column_needed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337448, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 481064, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309659, 139),
      ))
    }

@delegate:ResourceContentHash(1_161_905_812)
public val Res.string.staff_import_needs_connection: StringResource by lazy {
      StringResource("string:staff_import_needs_connection", "staff_import_needs_connection", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337608, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 481292, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309799, 137),
      ))
    }

@delegate:ResourceContentHash(-810_730_029)
public val Res.string.staff_import_note_name_already_in_team: StringResource by lazy {
      StringResource("string:staff_import_note_name_already_in_team", "staff_import_note_name_already_in_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337746, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 481522, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309937, 106),
      ))
    }

@delegate:ResourceContentHash(1_063_037_929)
public val Res.string.staff_import_note_name_duplicate_in_file: StringResource by lazy {
      StringResource("string:staff_import_note_name_duplicate_in_file", "staff_import_note_name_duplicate_in_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337861, 124),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 481697, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310044, 96),
      ))
    }

@delegate:ResourceContentHash(1_368_524_743)
public val Res.string.staff_import_note_new_role: StringResource by lazy {
      StringResource("string:staff_import_note_new_role", "staff_import_note_new_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 337986, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 481862, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310141, 78),
      ))
    }

@delegate:ResourceContentHash(-683_202_151)
public val Res.string.staff_import_note_shift_lead_not_configured: StringResource by lazy {
      StringResource("string:staff_import_note_shift_lead_not_configured", "staff_import_note_shift_lead_not_configured", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338061, 207),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 481965, 291),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310220, 175),
      ))
    }

@delegate:ResourceContentHash(-1_536_647_065)
public val Res.string.staff_import_or: StringResource by lazy {
      StringResource("string:staff_import_or", "staff_import_or", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338269, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482257, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310396, 27),
      ))
    }

@delegate:ResourceContentHash(-253_105_896)
public val Res.string.staff_import_paste_hint: StringResource by lazy {
      StringResource("string:staff_import_paste_hint", "staff_import_paste_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338301, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482289, 239),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310424, 175),
      ))
    }

@delegate:ResourceContentHash(565_581_858)
public val Res.string.staff_import_paste_label: StringResource by lazy {
      StringResource("string:staff_import_paste_label", "staff_import_paste_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338461, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482529, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310600, 48),
      ))
    }

@delegate:ResourceContentHash(1_009_632_744)
public val Res.string.staff_import_paste_read: StringResource by lazy {
      StringResource("string:staff_import_paste_read", "staff_import_paste_read", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338518, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482610, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310649, 59),
      ))
    }

@delegate:ResourceContentHash(-2_109_356_238)
public val Res.string.staff_import_paste_title: StringResource by lazy {
      StringResource("string:staff_import_paste_title", "staff_import_paste_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338586, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482714, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310709, 84),
      ))
    }

@delegate:ResourceContentHash(-1_371_680_392)
public val Res.string.staff_import_preview_title: StringResource by lazy {
      StringResource("string:staff_import_preview_title", "staff_import_preview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338679, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482835, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310794, 66),
      ))
    }

@delegate:ResourceContentHash(-884_414_854)
public val Res.string.staff_import_private_fields_hidden: StringResource by lazy {
      StringResource("string:staff_import_private_fields_hidden", "staff_import_private_fields_hidden", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338746, 194),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 482926, 298),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310861, 178),
      ))
    }

@delegate:ResourceContentHash(2_036_297_158)
public val Res.string.staff_import_problem_contract_unknown: StringResource by lazy {
      StringResource("string:staff_import_problem_contract_unknown", "staff_import_problem_contract_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 338941, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 483225, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311040, 73),
      ))
    }

@delegate:ResourceContentHash(1_449_280_555)
public val Res.string.staff_import_problem_email_already_in_team: StringResource by lazy {
      StringResource("string:staff_import_problem_email_already_in_team", "staff_import_problem_email_already_in_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339015, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 483327, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311114, 114),
      ))
    }

@delegate:ResourceContentHash(428_204_932)
public val Res.string.staff_import_problem_email_duplicate_in_file: StringResource by lazy {
      StringResource("string:staff_import_problem_email_duplicate_in_file", "staff_import_problem_email_duplicate_in_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339118, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 483502, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311229, 100),
      ))
    }

@delegate:ResourceContentHash(-292_537_147)
public val Res.string.staff_import_problem_email_invalid: StringResource by lazy {
      StringResource("string:staff_import_problem_email_invalid", "staff_import_problem_email_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339231, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 483675, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311330, 82),
      ))
    }

@delegate:ResourceContentHash(91_730_471)
public val Res.string.staff_import_problem_name_missing: StringResource by lazy {
      StringResource("string:staff_import_problem_name_missing", "staff_import_problem_name_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339314, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 483794, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311413, 53),
      ))
    }

@delegate:ResourceContentHash(-1_854_829_434)
public val Res.string.staff_import_problem_pay_model_unknown: StringResource by lazy {
      StringResource("string:staff_import_problem_pay_model_unknown", "staff_import_problem_pay_model_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339388, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 483896, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311467, 102),
      ))
    }

@delegate:ResourceContentHash(1_733_519_163)
public val Res.string.staff_import_problem_permission_not_allowed: StringResource by lazy {
      StringResource("string:staff_import_problem_permission_not_allowed", "staff_import_problem_permission_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339519, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484075, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311570, 95),
      ))
    }

@delegate:ResourceContentHash(869_965_803)
public val Res.string.staff_import_problem_permission_unknown: StringResource by lazy {
      StringResource("string:staff_import_problem_permission_unknown", "staff_import_problem_permission_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339619, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484219, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311666, 139),
      ))
    }

@delegate:ResourceContentHash(-293_452_424)
public val Res.string.staff_import_problem_phone_invalid: StringResource by lazy {
      StringResource("string:staff_import_problem_phone_invalid", "staff_import_problem_phone_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339787, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484479, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311806, 82),
      ))
    }

@delegate:ResourceContentHash(-675_514_731)
public val Res.string.staff_import_problem_rate_negative: StringResource by lazy {
      StringResource("string:staff_import_problem_rate_negative", "staff_import_problem_rate_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339874, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484594, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311889, 78),
      ))
    }

@delegate:ResourceContentHash(-1_395_282_913)
public val Res.string.staff_import_problem_rate_not_a_number: StringResource by lazy {
      StringResource("string:staff_import_problem_rate_not_a_number", "staff_import_problem_rate_not_a_number", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 339957, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484713, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311968, 78),
      ))
    }

@delegate:ResourceContentHash(338_485_503)
public val Res.string.staff_import_problem_shift_lead_unknown: StringResource by lazy {
      StringResource("string:staff_import_problem_shift_lead_unknown", "staff_import_problem_shift_lead_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340036, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484804, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312047, 83),
      ))
    }

@delegate:ResourceContentHash(-1_405_198_923)
public val Res.string.staff_import_problem_student_unknown: StringResource by lazy {
      StringResource("string:staff_import_problem_student_unknown", "staff_import_problem_student_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340132, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 484932, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312131, 88),
      ))
    }

@delegate:ResourceContentHash(978_367_823)
public val Res.string.staff_import_progress: StringResource by lazy {
      StringResource("string:staff_import_progress", "staff_import_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340229, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485065, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312220, 65),
      ))
    }

@delegate:ResourceContentHash(29_677_626)
public val Res.string.staff_import_rate_hourly: StringResource by lazy {
      StringResource("string:staff_import_rate_hourly", "staff_import_rate_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340295, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485147, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312286, 56),
      ))
    }

@delegate:ResourceContentHash(-111_692_738)
public val Res.string.staff_import_rate_monthly: StringResource by lazy {
      StringResource("string:staff_import_rate_monthly", "staff_import_rate_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340360, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485232, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312343, 61),
      ))
    }

@delegate:ResourceContentHash(-701_839_319)
public val Res.string.staff_import_read_only: StringResource by lazy {
      StringResource("string:staff_import_read_only", "staff_import_read_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340426, 158),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485318, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312405, 130),
      ))
    }

@delegate:ResourceContentHash(836_891_929)
public val Res.string.staff_import_reading: StringResource by lazy {
      StringResource("string:staff_import_reading", "staff_import_reading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340585, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485529, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312536, 56),
      ))
    }

@delegate:ResourceContentHash(-947_059_084)
public val Res.string.staff_import_row: StringResource by lazy {
      StringResource("string:staff_import_row", "staff_import_row", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340879, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485911, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312806, 36),
      ))
    }

@delegate:ResourceContentHash(-212_318_312)
public val Res.string.staff_import_row_added: StringResource by lazy {
      StringResource("string:staff_import_row_added", "staff_import_row_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340642, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485594, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312593, 54),
      ))
    }

@delegate:ResourceContentHash(1_130_893_146)
public val Res.string.staff_import_row_failed: StringResource by lazy {
      StringResource("string:staff_import_row_failed", "staff_import_row_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340697, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485669, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312648, 51),
      ))
    }

@delegate:ResourceContentHash(-827_067_033)
public val Res.string.staff_import_row_no_name: StringResource by lazy {
      StringResource("string:staff_import_row_no_name", "staff_import_row_no_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340753, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485733, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312700, 44),
      ))
    }

@delegate:ResourceContentHash(-115_573_962)
public val Res.string.staff_import_row_skipped: StringResource by lazy {
      StringResource("string:staff_import_row_skipped", "staff_import_row_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340818, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485822, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312745, 60),
      ))
    }

@delegate:ResourceContentHash(-570_197_982)
public val Res.string.staff_import_seats_left: StringResource by lazy {
      StringResource("string:staff_import_seats_left", "staff_import_seats_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340920, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 485956, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312843, 63),
      ))
    }

@delegate:ResourceContentHash(-1_185_611_380)
public val Res.string.staff_import_see_plans: StringResource by lazy {
      StringResource("string:staff_import_see_plans", "staff_import_see_plans", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 340984, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486040, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312907, 50),
      ))
    }

@delegate:ResourceContentHash(1_874_560_593)
public val Res.string.staff_import_sheet: StringResource by lazy {
      StringResource("string:staff_import_sheet", "staff_import_sheet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341031, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486115, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312958, 34),
      ))
    }

@delegate:ResourceContentHash(824_264_295)
public val Res.string.staff_import_skip: StringResource by lazy {
      StringResource("string:staff_import_skip", "staff_import_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341148, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486272, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313059, 33),
      ))
    }

@delegate:ResourceContentHash(-1_878_919_825)
public val Res.string.staff_import_skip_all: StringResource by lazy {
      StringResource("string:staff_import_skip_all", "staff_import_skip_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341066, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486158, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312993, 65),
      ))
    }

@delegate:ResourceContentHash(403_413_821)
public val Res.string.staff_import_start_over: StringResource by lazy {
      StringResource("string:staff_import_start_over", "staff_import_start_over", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341182, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486326, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313093, 59),
      ))
    }

@delegate:ResourceContentHash(-343_249_806)
public val Res.string.staff_import_student: StringResource by lazy {
      StringResource("string:staff_import_student", "staff_import_student", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341238, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486406, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313153, 52),
      ))
    }

@delegate:ResourceContentHash(-1_930_007_230)
public val Res.string.staff_import_template_download: StringResource by lazy {
      StringResource("string:staff_import_template_download", "staff_import_template_download", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341295, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486479, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313206, 74),
      ))
    }

@delegate:ResourceContentHash(-936_669_670)
public val Res.string.staff_import_template_hint: StringResource by lazy {
      StringResource("string:staff_import_template_hint", "staff_import_template_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341362, 150),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486570, 234),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313281, 150),
      ))
    }

@delegate:ResourceContentHash(217_112_295)
public val Res.string.staff_import_template_saved: StringResource by lazy {
      StringResource("string:staff_import_template_saved", "staff_import_template_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341513, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486805, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313432, 99),
      ))
    }

@delegate:ResourceContentHash(1_866_964_862)
public val Res.string.staff_import_template_title: StringResource by lazy {
      StringResource("string:staff_import_template_title", "staff_import_template_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341617, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 486949, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313532, 63),
      ))
    }

@delegate:ResourceContentHash(-1_907_978_984)
public val Res.string.staff_import_title: StringResource by lazy {
      StringResource("string:staff_import_title", "staff_import_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341689, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487029, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313596, 62),
      ))
    }

@delegate:ResourceContentHash(-1_813_457_292)
public val Res.string.staff_import_to_preview: StringResource by lazy {
      StringResource("string:staff_import_to_preview", "staff_import_to_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341740, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487096, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313659, 63),
      ))
    }

@delegate:ResourceContentHash(957_115_220)
public val Res.string.staff_import_unsupported: StringResource by lazy {
      StringResource("string:staff_import_unsupported", "staff_import_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 341800, 248),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487176, 392),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313723, 240),
      ))
    }

@delegate:ResourceContentHash(311_387_190)
public val Res.string.staff_medical_exam: StringResource by lazy {
      StringResource("string:staff_medical_exam", "staff_medical_exam", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342049, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487569, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 313964, 42),
      ))
    }

@delegate:ResourceContentHash(85_060_542)
public val Res.string.staff_medical_valid_until: StringResource by lazy {
      StringResource("string:staff_medical_valid_until", "staff_medical_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342100, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487632, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314007, 65),
      ))
    }

@delegate:ResourceContentHash(-2_059_469_052)
public val Res.string.staff_my_details: StringResource by lazy {
      StringResource("string:staff_my_details", "staff_my_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342170, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487730, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314073, 48),
      ))
    }

@delegate:ResourceContentHash(-871_359_705)
public val Res.string.staff_notes_edit: StringResource by lazy {
      StringResource("string:staff_notes_edit", "staff_notes_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342219, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487795, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314122, 48),
      ))
    }

@delegate:ResourceContentHash(-1_311_149_180)
public val Res.string.staff_notes_hint: StringResource by lazy {
      StringResource("string:staff_notes_hint", "staff_notes_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342276, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 487884, 236),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314171, 128),
      ))
    }

@delegate:ResourceContentHash(1_836_024_976)
public val Res.string.staff_notes_saved: StringResource by lazy {
      StringResource("string:staff_notes_saved", "staff_notes_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342417, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488121, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314300, 57),
      ))
    }

@delegate:ResourceContentHash(-871_359_705)
public val Res.string.staff_notes_title: StringResource by lazy {
      StringResource("string:staff_notes_title", "staff_notes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342487, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488239, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314358, 49),
      ))
    }

@delegate:ResourceContentHash(-149_488_340)
public val Res.string.staff_ohs_training: StringResource by lazy {
      StringResource("string:staff_ohs_training", "staff_ohs_training", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342601, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488409, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314464, 42),
      ))
    }

@delegate:ResourceContentHash(-388_097_619)
public val Res.string.staff_ohs_training_date: StringResource by lazy {
      StringResource("string:staff_ohs_training_date", "staff_ohs_training_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342545, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488329, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314408, 55),
      ))
    }

@delegate:ResourceContentHash(1_649_938_921)
public val Res.string.staff_ohs_valid_before_training: StringResource by lazy {
      StringResource("string:staff_ohs_valid_before_training", "staff_ohs_valid_before_training", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342648, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488468, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314507, 103),
      ))
    }

@delegate:ResourceContentHash(956_101_761)
public val Res.string.staff_ohs_valid_until: StringResource by lazy {
      StringResource("string:staff_ohs_valid_until", "staff_ohs_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342776, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488644, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314611, 61),
      ))
    }

@delegate:ResourceContentHash(-944_904_811)
public val Res.string.staff_shift_lead: StringResource by lazy {
      StringResource("string:staff_shift_lead", "staff_shift_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342838, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488734, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314673, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString40Resources(map: MutableMap<String, StringResource>) {
  map.put("staff_import_column_samples", Res.string.staff_import_column_samples)
  map.put("staff_import_count_fix", Res.string.staff_import_count_fix)
  map.put("staff_import_count_ready", Res.string.staff_import_count_ready)
  map.put("staff_import_count_skipped", Res.string.staff_import_count_skipped)
  map.put("staff_import_done_added", Res.string.staff_import_done_added)
  map.put("staff_import_done_back", Res.string.staff_import_done_back)
  map.put("staff_import_done_failed", Res.string.staff_import_done_failed)
  map.put("staff_import_done_hint", Res.string.staff_import_done_hint)
  map.put("staff_import_done_invite_failed", Res.string.staff_import_done_invite_failed)
  map.put("staff_import_done_invited", Res.string.staff_import_done_invited)
  map.put("staff_import_done_remaining", Res.string.staff_import_done_remaining)
  map.put("staff_import_done_title", Res.string.staff_import_done_title)
  map.put("staff_import_drop_hint", Res.string.staff_import_drop_hint)
  map.put("staff_import_drop_title", Res.string.staff_import_drop_title)
  map.put("staff_import_edit_save", Res.string.staff_import_edit_save)
  map.put("staff_import_edit_title", Res.string.staff_import_edit_title)
  map.put("staff_import_exceeds_seats", Res.string.staff_import_exceeds_seats)
  map.put("staff_import_exceeds_seats_ask_owner", Res.string.staff_import_exceeds_seats_ask_owner)
  map.put("staff_import_field_contract", Res.string.staff_import_field_contract)
  map.put("staff_import_field_email", Res.string.staff_import_field_email)
  map.put("staff_import_field_first_name", Res.string.staff_import_field_first_name)
  map.put("staff_import_field_last_name", Res.string.staff_import_field_last_name)
  map.put("staff_import_field_name", Res.string.staff_import_field_name)
  map.put("staff_import_field_none", Res.string.staff_import_field_none)
  map.put("staff_import_field_pay_model", Res.string.staff_import_field_pay_model)
  map.put("staff_import_field_permission", Res.string.staff_import_field_permission)
  map.put("staff_import_field_phone", Res.string.staff_import_field_phone)
  map.put("staff_import_field_rate", Res.string.staff_import_field_rate)
  map.put("staff_import_field_role", Res.string.staff_import_field_role)
  map.put("staff_import_field_shift_lead", Res.string.staff_import_field_shift_lead)
  map.put("staff_import_field_student", Res.string.staff_import_field_student)
  map.put("staff_import_fix", Res.string.staff_import_fix)
  map.put("staff_import_fix_first", Res.string.staff_import_fix_first)
  map.put("staff_import_has_header", Res.string.staff_import_has_header)
  map.put("staff_import_include", Res.string.staff_import_include)
  map.put("staff_import_intro", Res.string.staff_import_intro)
  map.put("staff_import_mapping_hint", Res.string.staff_import_mapping_hint)
  map.put("staff_import_mapping_title", Res.string.staff_import_mapping_title)
  map.put("staff_import_name_column_needed", Res.string.staff_import_name_column_needed)
  map.put("staff_import_needs_connection", Res.string.staff_import_needs_connection)
  map.put("staff_import_note_name_already_in_team", Res.string.staff_import_note_name_already_in_team)
  map.put("staff_import_note_name_duplicate_in_file", Res.string.staff_import_note_name_duplicate_in_file)
  map.put("staff_import_note_new_role", Res.string.staff_import_note_new_role)
  map.put("staff_import_note_shift_lead_not_configured", Res.string.staff_import_note_shift_lead_not_configured)
  map.put("staff_import_or", Res.string.staff_import_or)
  map.put("staff_import_paste_hint", Res.string.staff_import_paste_hint)
  map.put("staff_import_paste_label", Res.string.staff_import_paste_label)
  map.put("staff_import_paste_read", Res.string.staff_import_paste_read)
  map.put("staff_import_paste_title", Res.string.staff_import_paste_title)
  map.put("staff_import_preview_title", Res.string.staff_import_preview_title)
  map.put("staff_import_private_fields_hidden", Res.string.staff_import_private_fields_hidden)
  map.put("staff_import_problem_contract_unknown", Res.string.staff_import_problem_contract_unknown)
  map.put("staff_import_problem_email_already_in_team", Res.string.staff_import_problem_email_already_in_team)
  map.put("staff_import_problem_email_duplicate_in_file", Res.string.staff_import_problem_email_duplicate_in_file)
  map.put("staff_import_problem_email_invalid", Res.string.staff_import_problem_email_invalid)
  map.put("staff_import_problem_name_missing", Res.string.staff_import_problem_name_missing)
  map.put("staff_import_problem_pay_model_unknown", Res.string.staff_import_problem_pay_model_unknown)
  map.put("staff_import_problem_permission_not_allowed", Res.string.staff_import_problem_permission_not_allowed)
  map.put("staff_import_problem_permission_unknown", Res.string.staff_import_problem_permission_unknown)
  map.put("staff_import_problem_phone_invalid", Res.string.staff_import_problem_phone_invalid)
  map.put("staff_import_problem_rate_negative", Res.string.staff_import_problem_rate_negative)
  map.put("staff_import_problem_rate_not_a_number", Res.string.staff_import_problem_rate_not_a_number)
  map.put("staff_import_problem_shift_lead_unknown", Res.string.staff_import_problem_shift_lead_unknown)
  map.put("staff_import_problem_student_unknown", Res.string.staff_import_problem_student_unknown)
  map.put("staff_import_progress", Res.string.staff_import_progress)
  map.put("staff_import_rate_hourly", Res.string.staff_import_rate_hourly)
  map.put("staff_import_rate_monthly", Res.string.staff_import_rate_monthly)
  map.put("staff_import_read_only", Res.string.staff_import_read_only)
  map.put("staff_import_reading", Res.string.staff_import_reading)
  map.put("staff_import_row", Res.string.staff_import_row)
  map.put("staff_import_row_added", Res.string.staff_import_row_added)
  map.put("staff_import_row_failed", Res.string.staff_import_row_failed)
  map.put("staff_import_row_no_name", Res.string.staff_import_row_no_name)
  map.put("staff_import_row_skipped", Res.string.staff_import_row_skipped)
  map.put("staff_import_seats_left", Res.string.staff_import_seats_left)
  map.put("staff_import_see_plans", Res.string.staff_import_see_plans)
  map.put("staff_import_sheet", Res.string.staff_import_sheet)
  map.put("staff_import_skip", Res.string.staff_import_skip)
  map.put("staff_import_skip_all", Res.string.staff_import_skip_all)
  map.put("staff_import_start_over", Res.string.staff_import_start_over)
  map.put("staff_import_student", Res.string.staff_import_student)
  map.put("staff_import_template_download", Res.string.staff_import_template_download)
  map.put("staff_import_template_hint", Res.string.staff_import_template_hint)
  map.put("staff_import_template_saved", Res.string.staff_import_template_saved)
  map.put("staff_import_template_title", Res.string.staff_import_template_title)
  map.put("staff_import_title", Res.string.staff_import_title)
  map.put("staff_import_to_preview", Res.string.staff_import_to_preview)
  map.put("staff_import_unsupported", Res.string.staff_import_unsupported)
  map.put("staff_medical_exam", Res.string.staff_medical_exam)
  map.put("staff_medical_valid_until", Res.string.staff_medical_valid_until)
  map.put("staff_my_details", Res.string.staff_my_details)
  map.put("staff_notes_edit", Res.string.staff_notes_edit)
  map.put("staff_notes_hint", Res.string.staff_notes_hint)
  map.put("staff_notes_saved", Res.string.staff_notes_saved)
  map.put("staff_notes_title", Res.string.staff_notes_title)
  map.put("staff_ohs_training", Res.string.staff_ohs_training)
  map.put("staff_ohs_training_date", Res.string.staff_ohs_training_date)
  map.put("staff_ohs_valid_before_training", Res.string.staff_ohs_valid_before_training)
  map.put("staff_ohs_valid_until", Res.string.staff_ohs_valid_until)
  map.put("staff_shift_lead", Res.string.staff_shift_lead)
}
